import type { RootState } from "features/Application/globaltypes/redux";
import { createSelector } from "@reduxjs/toolkit";
import { RolePermissions } from "enums";

const selectPermissions = (state: RootState) => state.userProfile.permissions;

export const selectHasTemplateUsersTabAccess = createSelector([selectPermissions], (permissions: RolePermissions[]) => {
  const userRequiredPermissions = [RolePermissions.UsersView, RolePermissions.UsersManage];
  const hasUserPermission = userRequiredPermissions.some((permission) => permissions.includes(permission));

  const templateRequiredPermissions = [RolePermissions.TemplatesView, RolePermissions.TemplatesManage];
  const hasTemplatePermission = templateRequiredPermissions.some((permission) => permissions.includes(permission));

  return hasUserPermission && hasTemplatePermission;
});

export const selectHasTemplatesTabAccess = createSelector([selectPermissions], (permissions: RolePermissions[]) => {
  const requiredPermissions = [RolePermissions.TemplatesView, RolePermissions.TemplatesManage];

  return requiredPermissions.some((permission) => permissions.includes(permission));
});
